export default __webpack_public_path__ + "static/media/6012.1608432504.e85b7950-8f50-4344-83dd-1795737b05dc.5eebc7fb.webp";